module.exports = __webpack_public_path__ + "static/media/blank-group-picture.62286d23.png";